import logo from '../titl-new-logo.webp';
import joshuaImage from '../Joshua-Powder.webp';
import keronImage from '../Keron-Rose.webp';
import craigImage from '../Dr.-Craig-Ramlal.webp';
import { CalendarDays, Clock, MapPin, Ticket, type LucideIcon } from './components/Icon';

export const assets = { logo, joshuaImage, keronImage, craigImage };

export type EventFact = {
  label: string;
  value: string;
  Icon: LucideIcon;
};

export const eventFacts: EventFact[] = [
  { label: 'Date', value: 'Thursday, 13 August 2026', Icon: CalendarDays },
  { label: 'Time', value: '5:00–8:00 p.m.', Icon: Clock },
  { label: 'Venue', value: 'Victor E. Bruce Complex, Scarborough', Icon: MapPin },
  { label: 'Admission', value: 'Free · Limited RSVP', Icon: Ticket },
];

export const outcomes = [
  ['01', 'Find practical value', 'See where AI can support work, business, education, and public service.'],
  ['02', 'Prompt and verify', 'Learn how to improve AI outputs and check them before acting.'],
  ['03', 'Build visibility', 'Explore AI visibility, customer service, productivity, and research workflows.'],
  ['04', 'Use AI responsibly', 'Understand governance, safety, infrastructure, and Caribbean resilience.'],
] as const;

export const audienceGroups = [
  { title: 'Business & public service', text: 'Business owners, SME teams, managers, public servants, and community leaders.' },
  { title: 'Education & community', text: 'Educators, trainers, students, and anyone seeking a beginner-friendly entry point.' },
  { title: 'Technology & service', text: 'ICT, telecommunications, tourism, hospitality, and customer-service professionals.' },
] as const;

export const programme = [
  ['TITL AI Readiness opening', 'A Tobago-focused introduction to understanding, applying, governing, and enabling AI.'],
  ['Expert perspectives', 'Caribbean views on governance, business adoption, visibility, and the infrastructure behind AI.'],
  ['Discussion and questions', 'A forward-looking conversation with practical audience questions.'],
] as const;

export type Speaker = {
  id: string;
  name: string;
  topic: string;
  bio: string;
  image: string;
  imagePosition: string;
  featured: boolean;
};

export const speakers: Speaker[] = [
  {
    id: 'joshua-powder',
    name: 'Joshua Powder',
    topic: 'The Infrastructure Behind AI',
    bio: 'A technology infrastructure professional working across data-centre deployments, networking, colocation, scalable connectivity, and secure systems—the foundations that make modern AI possible.',
    image: joshuaImage,
    imagePosition: 'center 24%',
    featured: true,
  },
  {
    id: 'keron-rose',
    name: 'Keron Rose',
    topic: 'Winning in the AI-Mediated Economy',
    bio: 'A Trinidad and Tobago-born digital business strategist, educator, and founder of Digipreneur, helping Caribbean businesses build discoverability, authority, and growth in an AI-shaped economy.',
    image: keronImage,
    imagePosition: 'center 18%',
    featured: false,
  },
  {
    id: 'craig-ramlal',
    name: 'Dr Craig Ramlal',
    topic: 'Governing AI for Caribbean Reality',
    bio: 'Executive Director of The UWI Artificial Intelligence Innovation Centre and Chair of the CTU Caribbean AI Task Force, connecting AI research, governance, education, and regional development.',
    image: craigImage,
    imagePosition: 'center 20%',
    featured: false,
  },
];

export const faqs = [
  ['Is the symposium free?', 'Yes. Admission is free, but spaces are limited and RSVP is required.'],
  ['When and where is it?', 'Thursday, 13 August 2026, from 5:00–8:00 p.m. at Victor E. Bruce Financial Complex, Penthouse, Post Office Rd., Scarborough.'],
  ['Who is it for?', 'Professionals, businesses, educators, public servants, students, and anyone in Tobago who wants a practical understanding of AI.'],
  ['Do I need AI experience?', 'No. The symposium is designed for people who are new to AI as well as those already experimenting with it.'],
  ['Will the event be livestreamed?', 'Yes it will be livestreamed.'],
  ['Is there a course after the symposium?', 'TITL will introduce its planned Applied AI Foundations learning pathway at the symposium. Final course details will follow after approval.'],
] as const;
